import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import '@angular/common/locales/global/bg';
import '@angular/common/locales/global/cs';
import '@angular/common/locales/global/da';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/el';
import '@angular/common/locales/global/en-AU';
import '@angular/common/locales/global/en-GB';
import '@angular/common/locales/global/en-NZ';
import '@angular/common/locales/global/es';
import '@angular/common/locales/global/et';
import '@angular/common/locales/global/fi';
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/hr';
import '@angular/common/locales/global/hu';
import '@angular/common/locales/global/it';
import '@angular/common/locales/global/ja';
import '@angular/common/locales/global/lt';
import '@angular/common/locales/global/lv';
import '@angular/common/locales/global/nb'; //norwegisch bokmål
import '@angular/common/locales/global/nl';
import '@angular/common/locales/global/nn'; //norwegisch nynorsk
import '@angular/common/locales/global/pl';
import '@angular/common/locales/global/pt';
import '@angular/common/locales/global/ro';
import '@angular/common/locales/global/ru';
import '@angular/common/locales/global/sk';
import '@angular/common/locales/global/sl';
import '@angular/common/locales/global/sv';
import '@angular/common/locales/global/th';
import '@angular/common/locales/global/uk';
import '@angular/common/locales/global/zh';
import '@angular/common/locales/extra/bg';
import '@angular/common/locales/extra/cs';
import '@angular/common/locales/extra/da';
import '@angular/common/locales/extra/de';
import '@angular/common/locales/extra/el';
import '@angular/common/locales/extra/en-AU';
import '@angular/common/locales/extra/en-GB';
import '@angular/common/locales/extra/en-NZ';
import '@angular/common/locales/extra/es';
import '@angular/common/locales/extra/et';
import '@angular/common/locales/extra/fi';
import '@angular/common/locales/extra/fr';
import '@angular/common/locales/extra/hr';
import '@angular/common/locales/extra/hu';
import '@angular/common/locales/extra/it';
import '@angular/common/locales/extra/ja';
import '@angular/common/locales/extra/lt';
import '@angular/common/locales/extra/lv';
import '@angular/common/locales/extra/nb'; // norwegisch bokmål
import '@angular/common/locales/extra/nl';
import '@angular/common/locales/extra/nn'; // norwegisch nynorsk
import '@angular/common/locales/extra/pl';
import '@angular/common/locales/extra/pt';
import '@angular/common/locales/extra/ro';
import '@angular/common/locales/extra/ru';
import '@angular/common/locales/extra/sk';
import '@angular/common/locales/extra/sl';
import '@angular/common/locales/extra/sv';
import '@angular/common/locales/extra/th';
import '@angular/common/locales/extra/uk';
import '@angular/common/locales/extra/zh';
import 'moment/locale/cs';
import 'moment/locale/da';
import 'moment/locale/de';
import 'moment/locale/el';
import 'moment/locale/en-au';
import 'moment/locale/en-gb';
import 'moment/locale/en-nz';
import 'moment/locale/es';
import 'moment/locale/et';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/hr';
import 'moment/locale/hu';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/lt';
import 'moment/locale/lv';
import 'moment/locale/nb'; // norwegisch bokmål
import 'moment/locale/nl';
import 'moment/locale/nn'; // norwegisch nynorsk
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/sk';
import 'moment/locale/sv';
import 'moment/locale/th';
import 'moment/locale/uk';
import 'moment/locale/zh-cn';
import '@angular/compiler';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import {
  ConsoleTransport,
  FetchTransport,
  getWebInstrumentations,
  initializeFaro,
  InternalLoggerLevel,
  LogLevel,
  NavigationInstrumentation,
} from '@grafana/faro-web-sdk';

if (environment.production) {
  enableProdMode();
}

if (
  (environment.monitoring.faroCollectorUrl || environment.monitoring.enableLocalDebug) &&
  (environment.monitoring.enableMetrics || environment.monitoring.enableTracing)
) {
  initializeFaro({
    url: environment.monitoring.faroCollectorUrl, // Faro / Alloy collector endpoint
    app: {
      name: `soff-frontend${environment.monitoring.appNameSuffix || ''}`,
      version: '0.0.0',
      environment: environment.production ? 'production' : 'development',
    },
    transports: [
      ...(environment.monitoring.enableLocalDebug ? [new ConsoleTransport({ level: LogLevel.DEBUG })] : []),
      ...(!environment.monitoring.enableLocalDebug && environment.monitoring.faroCollectorUrl
        ? [new FetchTransport({ url: environment.monitoring.faroCollectorUrl })]
        : []),
    ],
    internalLoggerLevel: environment.monitoring.enableLocalDebug ? InternalLoggerLevel.VERBOSE : InternalLoggerLevel.OFF,
    instrumentations: [
      // Errors, web vitals, console, session, etc.
      ...(environment.monitoring.enableMetrics ? getWebInstrumentations() : []),
      // Optional: distributed tracing
      ...(environment.monitoring.enableTracing ? [new TracingInstrumentation()] : []),
      ...(environment.monitoring.enableNavigationInstrumentation ? [new NavigationInstrumentation()] : []),
    ],
  });
}
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    if ('serviceWorker' in navigator) {
      const { ttlMs, maxEntries } = environment.apiCache;
      const swUrl = `/machine-data-cache.sw.js?ttl=${ttlMs}&maxEntries=${maxEntries}`;
      navigator.serviceWorker.register(swUrl).catch(err => console.error('[machine-data-cache] Service worker registration failed', err));
    }
  })
  .catch(err => console.error(err));
